import React from "react";

export const HOUSING_TYPES = {
    HOUSE: "HOUSE",
    DEPARTMENT: "DEPARTMENT",
};

export const HOUSING_TYPE_LABELS = {
    [HOUSING_TYPES.HOUSE]: "Casa",
    [HOUSING_TYPES.DEPARTMENT]: "Departamento",
};

export const BUILDING_MATERIALS = {
    REINFORCED_CONCRETE: "REINFORCED_CONCRETE",
    BRICK_AND_CEMENT: "BRICKS_AND_CEMENT",
    STEEL: "STEEL",
};

export const BUILDING_MATERIALS_LABELS = {
    [BUILDING_MATERIALS.REINFORCED_CONCRETE]:
        "Ladrillo, cemento y fierro (con columnas y vigas)",
    [BUILDING_MATERIALS.BRICK_AND_CEMENT]: "Ladrillo y cemento (sin columnas ni vigas)",
    [BUILDING_MATERIALS.STEEL]: "Estructuras de Acero",
};

export const HOUSING_TYPE_OPTIONS = Object.keys(HOUSING_TYPE_LABELS).map(type => ({
    label: HOUSING_TYPE_LABELS[type],
    value: type,
}));

export const BUILDING_MATERIAL_OPTIONS = Object.keys(BUILDING_MATERIALS_LABELS).map(
    material => {
        return {
            label: BUILDING_MATERIALS_LABELS[material],
            value: material,
        };
    }
);
import concreteIcon from '../assets/images/icons/reinforced-concrete.svg'
import concreteIconSelected from '../assets/images/icons/reinforced-concrete-white.svg'
import brickIcon from '../assets/images/icons/brick-cement.svg'
import brickIconSelected from '../assets/images/icons/brick-cement-white.svg'
import stellIcon from '../assets/images/icons/steel.svg'
import stellIconSelected from '../assets/images/icons/steel-white.svg'


export const BUILDING_MATERIALS_VALUES = [
    {
        id: BUILDING_MATERIALS.REINFORCED_CONCRETE,
        description: BUILDING_MATERIALS_LABELS[BUILDING_MATERIALS.REINFORCED_CONCRETE],
        descriptionJsx: (
            <span className="d-block text-center">
                Ladrillo <br />
                cemento y fierro <br />
                (con columnas y vigas)
            </span>
        ),
        icon: "reinforced-concrete",
        selectedIcon: "reinforced-concrete-white",
        image: concreteIcon,
        imageSelected: concreteIconSelected
    },
    {
        id: BUILDING_MATERIALS.BRICK_AND_CEMENT,
        description: BUILDING_MATERIALS_LABELS[BUILDING_MATERIALS.BRICK_AND_CEMENT],
        descriptionJsx: (
            <span className="d-block text-center">
                Ladrillo y cemento <br />
                (sin columnas ni vigas)
            </span>
        ),
        icon: "brick-cement",
        selectedIcon: "brick-cement-white",
        image: brickIcon,
        imageSelected: brickIconSelected
    },
    {
        id: BUILDING_MATERIALS.STEEL,
        description: BUILDING_MATERIALS_LABELS[BUILDING_MATERIALS.STEEL],
        descriptionJsx: (
            <span className="d-block text-center">
                Estructuras <br /> de Acero
            </span>
        ),
        icon: "steel",
        selectedIcon: "steel-white",
        image: stellIcon,
        imageSelected: stellIconSelected
    },
];
import houseIcon from '../assets/images/icons/house-card.svg'
import houseIconSelected from '../assets/images/icons/house-card-alt.svg'
import departamentIcon from '../assets/images/icons/departament-card.svg'
import departamentIconSelected from '../assets/images/icons/departament-card-alt.svg'

export const HOUSING_TYPE_VALUES = [
    {
        id: HOUSING_TYPES.HOUSE,
        description: "Casa",
        icon: "house-card",
        selectedIcon: "house-card-alt",
        image: houseIcon,
        imageSelected: houseIconSelected,
    },
    {
        id: HOUSING_TYPES.DEPARTMENT,
        description: "Departamento",
        icon: "departament-card",
        selectedIcon: "departament-card-alt",
        image: departamentIcon,
        imageSelected: departamentIconSelected,
    },
];
